<template>
  <v-expansion-panel
    :style="{ background: $vuetify.theme.themes[theme].background }"
  >
    <slot />
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'DisplayExpansionPanel',
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
  },
};
</script>
